import React from 'react';
import { getProsAndCons,getProsAndConsYears } from "api/urls";
import { useHistory } from "react-router";
import { getQueryParams } from 'utils/Utils';

import ProsAndConsContainer from 'components/wrapper/ProsAndConsContainer';



const ProsAndCons = (props) => {

    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)


    return (
        <div  {...props}>
            <ProsAndConsContainer
                url={getProsAndCons(querryParams.company__symbol)}
                yearUrl={getProsAndConsYears(querryParams.company__symbol)}
            />
        </div>
    )
};

export default (ProsAndCons);
